export default "__VITE_ASSET__BHrBltww__ 400w, __VITE_ASSET__whmwpt72__ 800w, __VITE_ASSET__BljAkDW0__ 1024w";